import PenDetail from 'content/pages/Private/Pens/Detail';
import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const PensPage = Loader(lazy(() => import('content/pages/Private/Pens')));

const pensRouter: RouteObject[] = [
  {
    path: 'pens',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <PensPage />,
      },
      {
        path: ':penNumber',
        element: <PenDetail />,
      },
    ],
  },
];

export default pensRouter;
